"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conditionalString = exports.conditional = exports.nullable = void 0;
const assertions_1 = require("./assertions");
const nullable = (exp) => ((0, assertions_1.notFalsy)(exp) ? exp : null);
exports.nullable = nullable;
const conditional = (exp) => ((0, assertions_1.notFalsy)(exp) ? exp : undefined);
exports.conditional = conditional;
const conditionalString = (exp) => ((0, assertions_1.notFalsy)(exp) ? String(exp) : '');
exports.conditionalString = conditionalString;
